import type { ModuleDef } from './types.js';

/** Time: attendance, corrections, schedules, shifts, leave and holidays. */
export const TIME_MODULES: readonly ModuleDef[] = [
  {
    key: 'attendance',
    label: 'Attendance records',
    group: 'time',
    permissions: [
      { action: 'view', defaultRoles: ['HR', 'MANAGER'], description: 'See the live attendance board and the attendance calendar' },
      { action: 'create', defaultRoles: [], description: 'Enter a punch by hand on behalf of a worker' },
    ],
  },
  {
    key: 'attendance.scans',
    label: 'Flagged scans',
    group: 'time',
    permissions: [
      { action: 'view', defaultRoles: ['HR', 'MANAGER'], description: 'See the queue of flagged scans waiting for a decision' },
      { action: 'approve', defaultRoles: ['HR', 'MANAGER'], description: 'Accept or reject flagged scans' },
    ],
  },
  {
    key: 'corrections',
    label: 'Attendance corrections',
    group: 'time',
    permissions: [
      { action: 'approve', defaultRoles: ['HR', 'MANAGER'], description: 'Approve or reject correction requests' },
    ],
  },
  {
    key: 'schedules',
    label: 'Work schedules',
    group: 'time',
    permissions: [
      { action: 'view', defaultRoles: ['HR', 'MANAGER'], description: 'See the weekly schedule grid' },
      { action: 'create', defaultRoles: ['HR'], description: 'Copy a whole week of schedules onto another week' },
      { action: 'edit', defaultRoles: ['HR', 'MANAGER'], description: 'Assign shifts, fill ranges and import schedules' },
      { action: 'delete', defaultRoles: ['HR', 'MANAGER'], description: 'Clear a scheduled shift' },
      { action: 'export', defaultRoles: ['HR', 'MANAGER'], description: 'Download the schedule as a CSV file' },
    ],
  },
  {
    key: 'dispatch',
    label: 'Morning dispatch',
    group: 'time',
    permissions: [
      { action: 'view', defaultRoles: ['HR', 'MANAGER'], description: "See which site each worker is sent to today" },
      { action: 'edit', defaultRoles: ['HR', 'MANAGER'], description: 'Send workers to a site, or back to camp, for a day' },
      // HR only: the day is ONE plan for the whole company, so publishing it
      // is not a team-sized act. Managers build their crews into the draft.
      { action: 'approve', defaultRoles: ['HR'], description: "Publish the whole company's dispatch for the day" },
    ],
  },
  {
    key: 'shifts',
    label: 'Shift definitions',
    group: 'time',
    permissions: [
      { action: 'create', defaultRoles: ['HR'], description: 'Add a new shift' },
      { action: 'edit', defaultRoles: ['HR'], description: 'Change a shift or assign workers to it' },
      { action: 'delete', defaultRoles: [], description: 'Remove a shift' },
    ],
  },
  {
    key: 'leave.requests',
    label: 'Leave requests',
    group: 'time',
    permissions: [
      { action: 'view', defaultRoles: ['HR', 'MANAGER'], description: 'See the company leave calendar' },
      { action: 'approve', defaultRoles: ['HR', 'MANAGER'], description: 'Approve or reject leave requests' },
      { action: 'manage', defaultRoles: ['HR'], description: 'Cancel a leave request on a worker\'s behalf' },
    ],
  },
  {
    key: 'leave.types',
    label: 'Leave types',
    group: 'time',
    permissions: [
      { action: 'create', defaultRoles: ['HR'], description: 'Add a leave type' },
      { action: 'edit', defaultRoles: ['HR'], description: 'Change a leave type and its rules' },
      { action: 'delete', defaultRoles: [], description: 'Remove a leave type' },
    ],
  },
  {
    key: 'holidays',
    label: 'Public holidays',
    group: 'time',
    permissions: [
      { action: 'create', defaultRoles: ['HR'], description: 'Add a public holiday' },
      { action: 'edit', defaultRoles: ['HR'], description: 'Change a public holiday' },
      { action: 'delete', defaultRoles: ['HR'], description: 'Remove a public holiday' },
    ],
  },
  {
    key: 'siteops',
    label: 'Site operations',
    group: 'time',
    permissions: [
      { action: 'view', defaultRoles: ['HR', 'MANAGER'], description: 'See site coverage, live headcount and labour-limit compliance' },
    ],
  },
  {
    key: 'workforce.watch',
    label: 'Workforce watch',
    group: 'time',
    permissions: [
      { action: 'view', defaultRoles: ['HR', 'MANAGER'], description: 'See the workforce watch list of people needing attention' },
    ],
  },
];
